export const orderByDates = [
  {
    title: 'По умолчанию',
    value: ''
  },
  {
    title: 'Дата публикации ASC',
    value: 'createdAt_ASC'
  },
  {
    title: 'Дата публикации DESC',
    value: 'createdAt_DESC'
  },
  {
    title: 'Дата обновления ASC',
    value: 'updatedAt_ASC'
  },
  {
    title: 'Дата обновления DESC',
    value: 'updatedAt_DESC'
  }
  // {
  //   title: 'Дата начала ASC',
  //   value: 'dateFrom_ASC'
  // },
  // {
  //   title: 'Дата начала DESC',
  //   value: 'dateFrom_DESC'
  // },
  // {
  //   title: 'Дата окончания ASC',
  //   value: 'dateTo_ASC'
  // },
  // {
  //   title: 'Дата окончания DESC',
  //   value: 'dateTo_DESC'
  // }
]
